import React, {Fragment} from 'react';
import { FormattedMessage } from 'react-intl';
import './Footer.scss'

const DefaultLinks = () => (
  <ul className="Footer__List">
    <a className="Footer__Link" href={`${MDLIVE_BASE_URL}/privacy_policy`}><FormattedMessage id="privacyPolicy" /></a>
    <a className="Footer__Link" href={`${MDLIVE_BASE_URL}/terms_of_use`}><FormattedMessage id="termsOfUse" /></a>
    <a className="Footer__Link" href={`${MDLIVE_BASE_URL}/disclaimers`}><FormattedMessage id="disclaimer" /></a>
    <a className="Footer__Link" href={`${MDLIVE_BASE_URL}/notice-of-non-discrimination`}><FormattedMessage id="noticeOfNonDiscrimination" /></a>
  </ul>
)

const FooterLink = ({text, href}) => (
  <a className="Footer__Link" href={href}>{text}</a>
)

const FooterLinkRow = ({links}) => (
  <ul className="Footer__List">
    {links.map(link => <FooterLink key={link.text} text={link.text} href={link.href} />)}
  </ul>
)

const Footer = ({footerLinks, customFooterHtml}) => (
  <footer className="Footer">
    <div className="Footer__Wrapper container">
      <div><FormattedMessage id="copyright" values={{year: new Date().getFullYear()}}/></div>

      { footerLinks && footerLinks.length > 0 && footerLinks[0] && footerLinks[0].length > 0 ? 
          footerLinks.map((footerRow, i) => <FooterLinkRow key={i} links={footerRow} />)
          : <DefaultLinks />}

      { customFooterHtml && (
        <Fragment>
          <br/>
          <div dangerouslySetInnerHTML={{__html: customFooterHtml}} />
        </Fragment>
      )}
    </div>
  </footer>
)

export default Footer;



// WEBPACK FOOTER //
// ./registration-react/components/Footer/Footer.js